var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-inline-block",style:(_vm.$style.gamePhotoCard)},[_c('img',{staticStyle:{"border-radius":"30px"},attrs:{"src":_vm.getImgUrl(_vm.game.image)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }